"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DRAWER_MIN_HEIGHT_PERCENTAGE = exports.DRAWER_MAX_HEIGHT_PERCENTAGE = void 0;
const DRAWER_MIN_HEIGHT_PERCENTAGE = exports.DRAWER_MIN_HEIGHT_PERCENTAGE = 46;
const DRAWER_MAX_HEIGHT_PERCENTAGE = exports.DRAWER_MAX_HEIGHT_PERCENTAGE = 81;